import { Home, Settings } from "lucide-react";
import { Sidebar } from "../../../components/Sidebar";

export const WorkspaceSidebar = ({ organization }: { organization: any }) => {

    const sections = [
        {
            visible: true,
            links: [
                {
                    to: `/o/${organization?.tag}`,
                    text: "Dashboard",
                    iconComponent: <Home size={16} />,
                    enabled: true,
                    visible: true,
                    end: true,
                },
                {
                    to: `/o/${organization?.tag}/settings`,
                    text: "Settings",
                    iconComponent: <Settings size={16} />,
                    enabled: true,
                    visible: true,
                }
            ],
        },
    ];

    return (
        <Sidebar sections={sections} />
    );
};